import { Storage } from "megajs";

let isConnected = false;
let storage;

export function isOnline() {
  return navigator.onLine;
}

export function getMegaConnectionStatus() {
  return isConnected;
}

function initializeStorage() {
  return new Promise((resolve, reject) => {
    if (!isOnline()) {
      return reject(new Error("No internet connection."));
    }

    storage = new Storage({
      email: "blissdistroinfo@gmail.com",
      password: "@Bliss1994",
    });

    storage.on("ready", () => {
      console.log("✅ Connected to MEGA storage.");
      isConnected = true;
      resolve(storage);
    });

    storage.on("error", (error) => {
      console.error("❌ MEGA connection error:", error);
      isConnected = false;
      reject(error);
    });
  });
}

export async function uploadFileToMega(file, folderName) {
  try {
    if (!file) throw new Error("No file provided for upload.");
    if (!isOnline()) return { error: "No internet connection. Try again later." };

    // Initialize MEGA only if not connected yet
    if (!isConnected || !storage) {
      await initializeStorage();
    }

    const fileName = file.name;
    const arrayBuffer = await file.arrayBuffer();
    const buffer = new Uint8Array(arrayBuffer);

    if (!buffer.length) throw new Error("File buffer is empty or invalid.");

    const root = storage.mounts[0];
    let coverFolder = root?.children.find((child) => child.name === folderName);

    if (!coverFolder) {
      coverFolder = await root.mkdir(folderName);
    }

    const fileUploaded = await coverFolder.upload(fileName, buffer).complete;
    return {
      name: fileUploaded.name,
      size: fileUploaded.size,
      timestamp: fileUploaded.timestamp,
      directory: fileUploaded.directory,
      nodeId: fileUploaded.nodeId,
      downloadId: fileUploaded.downloadId,
    };
  } catch (error) {
    console.error("❌ Error uploading file:", error);
    return { error: "File upload failed: " + error.message };
  }
}

export { storage };